import $http from '../../../axios-instance';
import Swal from 'sweetalert2'

/**
 * Mostrar los pictogramas de un producto
 * @param payload: order, start_date, quantity, company_id, comment,state
 * @returns {Promise} orden creada
 * @autor Paul Valencia
 */
export async function saveIcons({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        await $http.post('et_product_icons', payload);
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Mostrar los pictogramas de un producto
 * @param payload: order, start_date, quantity, company_id, comment,state
 * @returns {Promise} orden creada
 * @autor Paul Valencia
 */
export async function getIcons({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get('et_product_icons', {params: {...payload}});
        return await Promise.resolve(response.data);
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}

